<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>reviews</md-icon>
          </div>
          <h4 class="title">Create Review Request</h4>
        </md-card-header>

        <md-card-content>
          
          <!-- REVIEW REQUEST FORM -->
          <form @submit.prevent="submitReviewRequest">

            <!-- Email -->
            <md-field>
              <label>Email</label>
              <md-input 
                v-model="form.email" 
                placeholder="Enter user email"
              />
            </md-field>

            <!-- Email Subject -->
            <md-field>
              <label>Email Subject</label>
              <md-input 
                v-model="form.subject" 
                placeholder="Email subject"
              />
            </md-field>

            <!-- Email Body (vue2-editor) -->
            <label><b>Email Body</b></label>
            <vue-editor v-model="form.body"></vue-editor>

            <md-button 
              class="md-success md-raised submit-btn"
              type="submit"
              :disabled="isDisabled"
            >
              Create Review Request <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
            </md-button>

          </form>
        </md-card-content>

      </md-card>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import UsersDataService from "../../services/SuperAdmin/UsersDataService";
//import ReviewService from "../../services/SuperAdmin/ReviewService"; // You will create thi

export default {
  components: { VueEditor },

  data() {
    const orderNumber = this.$route.query.orderNumber || "12345";
    return {
      isDisabled: false,
      form: {
        email: this.$route.query.email,
        subject: "Your Order Confirmation",
        body: `<p>Your order ${orderNumber} has been shipped.</p>`
      }
    };
  },

  methods: {
    // Submit review request
    submitReviewRequest() {
        this.isDisabled = true;
      UsersDataService.createReviewRequest(this.form)
        .then(() => {
            this.isDisabled = false;
          this.$toast.success("Review request created successfully!");
          this.resetForm();
        })
        .catch(e => {
            this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },

    resetForm() {
      this.form = {
        email: "",
        name: "",
        orderNumber: "",
        subject: "",
        body: "",
      };
    }
  }
};
</script>

<style scoped>
.submit-btn {
  margin-top: 20px;
}
</style>
